//Author June Leow
//Date June 6th, 2024
import Avatar from "react-avatar-edit";
import {getReducer, getSetStateFunction, getAPICallGenerator, postAPICallGenerator, putAPICallGenerator, deleteAPICallGenerator, callBackGenerator, getSession, formatNumber, confirmation, showMessage, formatDate} from '../../util/util';
import {Button, Col, Row, Table, Input, Modal, ModalBody,ModalHeader, Card, CardHeader, CardBody} from 'reactstrap';
import DatePicker from 'react-datepicker';
import FileSaver from 'file-saver';
import moment from 'moment';
import MyDropzone from '../util/my-dropzone';
import MyXEditable from '../util/my-xeditable';
import {NavLink} from 'react-router-dom';
import React, {useReducer, useEffect} from 'react';
import { useParams } from "react-router-dom";
import Toggle from 'react-toggle';
import './setting.css';
import ReactDOM from 'react-dom';
//initialize the state

let showUpload = (!localStorage.getItem('profilePhoto') || localStorage.getItem('profilePhoto')==='');
let profileUrl = localStorage.getItem('profilePhoto')?localStorage.getItem('profilePhoto'):'';
let typeID = localStorage.getItem('typeID');

const initialState = {
  profileUrl:profileUrl,
  typeID:typeID,
  showUpload:showUpload,
  photoSrc:null,
  photoPreview:null,
  templateTags:[],
  templates:[],
  newTemplateName:'',
  newTemplateText:'',
  appraiser:{},

  appraisalTypeFees:[],
  appraisalTypes:[],
  addNewTemplateDropDownOpen:false,

  newAppraisalTypeFeeSelection:'',
  newAppraisalTypeFeeAmount:'',

  appraiserFeePopUp:false,
  appraiserDocumentPopUp:false,
  appraiserResponseTimeAndpreferredPopUp:false,
  appraiserVacationSchedulePopUp:false,
  appraiserAboutMePopUp:false,

  appraiserFiles:[],
  toUploadFiles:[],
  errorMessage:'',
  fileTypes:[],

  communicationMethods:[],
  responseTime:4.0,
  communicationMethod:'',
  uploadDisabled:false,

  states:[
    {key:'Alabama',value:'Alabama'},{key:'Alaska',value:'Alaska'},{key:'Arizona',value:'Arizona'},{key:'Arkansas',value:'Arkansas'},{key:'California',value:'California'},{key:'Colorado',value:'Colorado'},{key:'Connecticut',value:'Connecticut'},{key:'Delaware',value:'Delaware'},{key:'Florida',value:'Florida'},{key:'Georgia',value:'Georgia'},{key:'Hawaii',value:'Hawaii'},{key:'Idaho',value:'Idaho'},{key:'Illinois',value:'Illinois'},{key:'Indiana',value:'Indiana'},{key:'Iowa',value:'Iowa'},{key:'Kansas',value:'Kansas'},{key:'Kentucky',value:'Kentucky'},{key:'Louisiana',value:'Louisiana'},{key:'Maine',value:'Maine'},{key:'Maryland',value:'Maryland'},{key:'Massachusetts',value:'Massachusetts'},{key:'Michigan',value:'Michigan'},{key:'Minnesota',value:'Minnesota'},{key:'Mississippi',value:'Mississippi'},{key:'Missouri',value:'Missouri'},{key:'Montana',value:'Montana'},{key:'Nebraska',value:'Nebraska'},{key:'Nevada',value:'Nevada'},{key:'New Hampshire',value:'New Hampshire'},{key:'New Jersey',value:'New Jersey'},{key:'New Mexico',value:'New Mexico'},{key:'New York',value:'New York'},{key:'North Carolina',value:'North Carolina'},{key:'North Dakota',value:'North Dakota'},{key:'Ohio',value:'Ohio'},{key:'Oklahoma',value:'Oklahoma'},{key:'Oregon',value:'Oregon'},{key:'Pennsylvania',value:'Pennsylvania'},{key:'Rhode Island',value:'Rhode Island'},{key:'South Carolina',value:'South Carolina'},{key:'South Dakota',value:'South Dakota'},{key:'Tennessee',value:'Tennessee'},{key:'Texas',value:'Texas'},{key:'Utah',value:'Utah'},{key:'Vermont',value:'Vermont'},{key:'Virgin Islands',value:'Virgin Islands'},{key:'Virginia',value:'Virginia'},{key:'Washington',value:'Washington'},{key:'Washington DC',value:'Washington DC'},{key:'West Virginia',value:'West Virginia'},{key:'Wisconsin',value:'Wisconsin'},{key:'Wyoming',value:'Wyoming'}
  ],
  emailSettings:[],

  oldPassword:'',
  newPassword:'',
  showPassword:false,
  isFocused:false,
  confirmNewPassword:'',

  resizeFilePopUp:false,
  bigFiles:[],
};

//reducer function that perform state update
const reducer = getReducer();


const PersonalSetting  = (props)=>{
  const controller = new AbortController();

  let param = useParams().param;
  let scrollToBottom = false;
  if(param && param==='password'){
    scrollToBottom = true;
  }


  let newInitialState = Object.assign({}, initialState, {
    scrollToBottom:scrollToBottom
  });

  const [state, dispatch] = useReducer(reducer,newInitialState);


  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpGet = getAPICallGenerator(props, {signal:controller.signal});
  const httpPost = postAPICallGenerator(props, {signal:controller.signal});
  const httpPut = putAPICallGenerator(props, {signal:controller.signal});
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    getTemplates();
    //getStates();
    getCommunicationMethods();
    getAppraiserFiles();
    getFileTypes();
    getMyProfile();
    getTemplateTags();
    getAppraiserappraisalTypeFees();
    getAppraisalTypes();
    getEmailNotificationSettings();

    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const documentToggle = () => {
    setState({ appraiserDocumentPopUp: !state.appraiserDocumentPopUp });
  };

  const responseTimeAndpreferredToggle = () => {
    setState({ appraiserResponseTimeAndpreferredPopUp: !state.appraiserResponseTimeAndpreferredPopUp });
  };

  const vacationToggle = () => {
    setState({ appraiserVacationSchedulePopUp: !state.appraiserVacationSchedulePopUp });
  };

  const aboutMeToggle = () => {
    setState({ appraiserAboutMePopUp: !state.appraiserAboutMePopUp });
  };

  const feeToggle = () => {
    
  };

  const smsSubscriptionChange = () => {
    if (state.appraiser.sms_subscription === 'yes') {
      updateField('sms_subscription', 'no');
    } else {
      updateField('sms_subscription', 'yes');
    }
  };

  const toggleAddNewTemplateDropDown = () => {
    setState({ addNewTemplateDropDownOpen: !state.addNewTemplateDropDownOpen });
  };

  const addTag = (e, tag) => {
    e.preventDefault();
    setState({ newTemplateText: state.newTemplateText + ' [:' + tag + ']' });
  };

  const onClose = () => {
    setState({ photoPreview: null });
  };

  const onCrop = (preview) => {
    setState({ photoPreview: preview });
  };

  const onBeforeFileLoad = (elem) => {
    if (elem.target.files[0].size > 15000000) {
      showMessage('error', 'Photo is too big.');
      elem.target.value = '';
    }
  };

  const toggleResizeFile = () => {
    if (state.resizeFilePopUp) {
      setState({ bigFiles: [] });
    }
    setState({ resizeFilePopUp: !state.resizeFilePopUp });
  };

  const handlePasswordChange = (e) => {
    setState({ newPassword: e.target.value });
  };

  const handlePasswordFocus = () => {
    setState({ isFocused: true });
  };

  const handlePasswordBlur = () => {
    setState({ isFocused: false });
  };

  const handleToggle = () => {
    setState({ showPassword: !state.showPassword });
  };

  const buttonHandler = () => {
    if (state.uploadDisabled) return;
    setState({ uploadDisabled: true });
    uploadAll();
  };

  const isPasswordValid = (password, type = '') => {
    const lowerCaseLetters = /[a-z]/g;
    const upperCaseLetters = /[A-Z]/g;
    const numbers = /[0-9]/g;
    const specialCharacters = /[!@#$%^&*]/g;
    const isLowerCaseValid = password.match(lowerCaseLetters);
    const isUpperCaseValid = password.match(upperCaseLetters);
    const isNumberValid = password.match(numbers);
    const isSpecialCharacterValid = password.match(specialCharacters);
    const isLengthValid = password.length >= 12;

    if (type === 'lowercase') {
      return isLowerCaseValid;
    } else if (type === 'uppercase') {
      return isUpperCaseValid;
    } else if (type === 'number') {
      return isNumberValid;
    } else if (type === 'special') {
      return isSpecialCharacterValid;
    } else if (type === 'length') {
      return isLengthValid;
    } else {
      return (
        isLowerCaseValid &&
        isUpperCaseValid &&
        isNumberValid &&
        isSpecialCharacterValid &&
        isLengthValid
      );
    }
  };

  const emailNotificationToggle = (subject) => {
    for (let i = 0; i < state.emailSettings.length; i++) {
      if (state.emailSettings[i].subject === subject) {
        if (state.emailSettings[i].blocked === 'yes') {
          unblockEmail(subject);
        } else {
          blockEmail(subject);
        }
      }
    }
  };

  const updateFieldCallBack = (field, value) => {
    let appraiser = { ...state.appraiser };
    appraiser[field] = value;
    setState({ appraiser });
  };

  //API call
  const getEmailNotificationSettings = () => {
    const callBack = (response) => {
        const code = response.data.code;
        if (code === '00') {
            setState({ emailSettings: response.data.data });
        }
    };

    httpGet('email/get', '', 'Oops, something went wrong and could not load email notification settings. Please try again later.', callBack);
};

const blockEmail = (subject) => {
    const parameters = [{ field: 'subject', value: subject }];

    const callBack = (response) => {
        const code = response.data.code;
        if (code === '00') {
            const emailSettings = [...state.emailSettings];
            for (let i = 0; i < emailSettings.length; i++) {
                if (emailSettings[i].subject === subject) {
                    emailSettings[i].blocked = 'yes';
                    break;
                }
            }
            setState({ emailSettings });
        }
    };

    httpPost('email/block', parameters, 'Email notification disabled.', 'Oops, something went wrong and could not disable the email notification. Please try again later.', callBack);
};

const unblockEmail = (subject) => {
    const callBack = (response) => {
        const code = response.data.code;
        if (code === '00') {
            const emailSettings = [...state.emailSettings];
            for (let i = 0; i < emailSettings.length; i++) {
                if (emailSettings[i].subject === subject) {
                    emailSettings[i].blocked = 'no';
                    break;
                }
            }
            setState({ emailSettings });
        }
    };

    httpDelete('email/' + subject, 'Email notification enabled successfully.', 'Oops, something went wrong and could not enable the email notification. Please try again later.', callBack);
};

const updatePassword = () => {
    if (state.oldPassword === '') {
        setState({ changePasswordMessage: 'Please provide your current password.' });
    } else if (!isPasswordValid(state.newPassword)) {
        setState({ changePasswordMessage: 'Please match the required format.' });
    } else if (state.newPassword !== state.confirmNewPassword) {
        setState({ changePasswordMessage: 'Your new password does not match.' });
    } else {
        const parameters = [
            { field: 'oldPassword', value: state.oldPassword },
            { field: 'newPassword', value: state.newPassword }
        ];

        const callBack = (response) => {
            const code = response.data.code;
            if (code === '00') {
                setState({ newPassword: '', confirmNewPassword: '', oldPassword: '' });
            }
        };

        httpPost('session/updatePassword', parameters, 'Password updated.', 'Oops, something went wrong and could not update your password. Please try again later.', callBack);
    }
};

const uploadProfilePhoto = () => {
    const parameters = [{ field: 'photo', value: state.photoPreview }];

    const callBack = (response) => {
        const code = response.data.code;
        if (code === '00') {
            const data = response.data.data;
            localStorage.setItem('profilePhoto', data);
            setState({ profileUrl: data });
            window.location.reload();
        }
    };

    httpPost('user/photo/upload', parameters, 'Profile photo uploaded.', 'Oops, something went wrong and could not upload your profile photo. Please try again later.', callBack);
};

const submitNewAppraisalTypeFee = (e) => {
    e.preventDefault();

    const parameters = [
        { field: 'appraiser_fk', value: state.id },
        { field: 'appraisal_type', value: state.newAppraisalTypeFeeSelection },
        { field: 'fee', value: state.newAppraisalTypeFeeAmount }
    ];

    const callBack = (response) => {
        const code = response.data.code;
        if (code === '00') {
            setState({ newAppraisalTypeFeeAmount: '', newAppraisalTypeFeeSelection: '' });
            const appraisalTypeFees = [...state.appraisalTypeFees, response.data.data];
            setState({ appraisalTypeFees });
        }
    };

    httpPost('appraiser/appraisalTypeFees/create', parameters, 'Report type & fee entry created successfully.', 'Oops, something went wrong and could not create this report type & fee entry. Please try again later.', callBack);
};

const addNewTemplate = (e) => {
    e.preventDefault();

    const parameters = [
        { field: 'name', value: state.newTemplateName },
        { field: 'template', value: state.newTemplateText }
    ];

    const callBack = (response) => {
        const code = response.data.code;
        if (code === '00') {
            const templates = [...state.templates, response.data.data];
            setState({ templates });
            toggleAddNewTemplateDropDown();
        }
    };

    httpPost('template/create', parameters, 'Template created successfully.', 'Oops, something went wrong and could not create the template. Please try again later.', callBack);
};

const getMyProfile = () => {
  const callBack = apiCallBack([{state:'appraiser', key:'data'}]);
  httpGet('appraiser/' + getSession().userID, '', 'Oops, something went wrong and could not load your profile. Please try again later.', callBack);
};

const getTemplates = () => {
  const callBack = apiCallBack([{state:'templates', key:'data'}]);
  httpGet('template/get/-1', '', 'Oops, something went wrong and could not load your templates. Please try again later.', callBack);
};

const getCommunicationMethods = () => {
  const callBack = apiCallBack([{state:'communicationMethods', key:'data'}]);
  httpGet('appraiser/communicationMethod/get', '', 'Oops, something went wrong and could not load communication methods. Please try again later.', callBack);
};

const removeAppraisalTypeFee = (id) => {
  const callBack = (response) => {
      const code = response.data.code;
      if (code === '00') {
          const appraisalTypeFees = state.appraisalTypeFees.filter(fee => fee.ID !== id);
          setState({ appraisalTypeFees });
      }
  };

  httpDelete('appraiser/appraisalTypeFees/' + id, 'Entry removed.', 'Failed to remove the entry, please try again later.', callBack);
};

const getTemplateTags = () => {
  const callBack = apiCallBack([{state:'templateTags', key:'data'}]);
  httpGet('template/tag/get', '', 'Oops, something went wrong and could not load tags for template. Please try again later.', callBack);
};

const deleteTemplate = (id) => {
    const callBack = (response) => {
        const code = response.data.code;
        if (code === '00') {
            const templates = state.templates.filter(template => template.ID !== id);
            setState({ templates });
        }
    };

    httpDelete('template/' + id, 'Template deleted successfully.', 'Oops, something went wrong and could not delete the template. Please try again later.', callBack);
};

const updateField = (field, value) => {
    const parameters = [
        { field: 'field', value: field },
        { field: 'value', value: value }
    ];

    const callBack = (response) => {
        const code = response.data.code;
        if (code === '00') {
            const appraiser = { ...state.appraiser, [field]: value };
            setState({ appraiser });
        }
    };

    httpPut('appraiser/update', parameters, 'Profile updated.', 'Oops, something went wrong and could not update your profile. Please try again later.', callBack);
};

const getAppraisalTypes = () => {
    const callBack = (response) => {
        const code = response.data.code;
        if (code === '00') {
            const appraisalTypes = response.data.data.map(type => ({
                key: type.appraisal_type,
                value: type.external_label
            }));
            const subAppraisalTypes = response.data.data.filter(type => type.sub_form === 'yes').map(type => ({
                key: type.appraisal_type,
                value: type.external_label
            }));
            setState({ appraisalTypes, subAppraisalTypes });
        }
    };

    httpGet('appraisalType/get/externalLabel', '', 'Oops, something went wrong and could not load list of available report types. Please try again later.', callBack);
};

const getAppraiserappraisalTypeFees = () => {
    const callBack = apiCallBack([{state:'appraisalTypeFees', key:'data'}]);
    httpGet('appraiser/appraisalTypeFees/get/' + getSession().userID, '', 'Oops, something went wrong and could not load this appraiser profile. Please try again later.', callBack);
};

const unsubscribeChannel = (id) => {
    const callBack = (response) => {
        const code = response.data.code;
        if (code === '00') {
            const channels = state.channels.map(channel =>
                channel.ID === id ? { ...channel, subscribed: 'no' } : channel
            );
            setState({ channels });
        }
    };

    httpDelete('notification/channel/unsubscribe/' + id, 'Channel unsubscribed successfully.', 'Oops, something went wrong and could not unsubscribe the channel. Please try again later.', callBack);
};

const downloadFile = (name) => {
    const downloadFileCallBack = (response) => {
        const code = response.data.code;
        if (code === '00') {
            const byteCharacters = atob(response.data.data);
            const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
            const byteArray = new Uint8Array(byteNumbers);
            const data = new Blob([byteArray]);
            FileSaver.saveAs(data, name);
        }
    };

    const parameters = [
        { field: 'parentFk', value: getSession().userID },
        { field: 'name', value: name },
        { field: 'directory', value: 'Appraisers' }
    ];

    httpPost('appraiser/file/download', parameters, '', `Oops, something went wrong and could not download the file "${name}". Please try again later.`, downloadFileCallBack);
};

const deleteFile = (ID) => {
    const deleteFileCallBack = (response) => {
        const code = response.data.code;
        if (code === '00') {
            removeFileFromList(ID);
        }
    };

    httpDelete('appraiser/file/' + ID, '', 'Oops, something went wrong and could not delete the file, please try again later.', deleteFileCallBack);
};

const uploadAll = () => {
  let preCheck = true;
  let errorMessage = '';
  let fileTypes = [];

  for(let i =0; i<state.toUploadFiles.length;i++){
    if(state.toUploadFiles[i].fileType===''){
      errorMessage = "One or more file type is not selected.";
      preCheck = false;
      break;
    }
  }

  if (preCheck) {
      setState({ errorMessage: 'Uploading...Please do not close the window.' });
      let fileCompleted = 0;
      for(let i=0;i<state.toUploadFiles.length;i++){
        //skip file that has done upload
        if(state.toUploadFiles[i].status==='Done')
          continue;
        const reader = new FileReader();
        // eslint-disable-next-line no-loop-func
        reader.onload = () => {
            const fileAsBinaryString = reader.result;
            let base64 = btoa(fileAsBinaryString);

            let callBack = (response)=>{
              let code = response.data.code;

              if(code==='00'){
                //copy the array so we maintaining the immutable state
                let newToUploadFiles = [];

                //deep copy the entire file object array
                for(let j=0;j<state.toUploadFiles.length;j++){
                  let newFile;

                  try{
                    newFile = this.deepCopyFileObject(state.toUploadFiles[j]);

                    if(newFile.name===state.toUploadFiles[i].name)
                      newFile.status='Done';


                    newToUploadFiles.push(newFile);
                  }
                  catch(err){
                    //IE Error , not supporting file consturctor
                  }
                }

                setState({toUploadFiles:newToUploadFiles});

                //update the list of uploaded file
                setState({appraiserFiles:response.data.data}, "CONCAT_SET_STATES");
              }
              fileCompleted++;
              if(fileCompleted>=state.toUploadFiles.length){
                setState({uploadDisabled:false,errorMessage:''});
              }
            };
            
            let errorCallBack = (error)=>{
              fileCompleted++;

              if(fileCompleted>=state.toUploadFiles.length){
                setState({uploadDisabled:false,errorMessage:''});
              }
            };

            let parameters = [
              {
                field:'appraiserFk',
                value:state.typeID
              },
              {
                field:'file_type',
                value:state.toUploadFiles[i].fileType
              },
              {
                field:'upload_type',
                value:'Appraisers'
              },
              {
                field:'name',
                value:state.toUploadFiles[i].name
              }
              ,{
                field:'file_encoded',
                value:base64
              }
            ];

            httpPost('appraiser/upload', parameters, `File "${state.toUploadFiles[i].name}" uploaded successfully.`, `Oops, something went wrong and could not upload the file "${state.toUploadFiles[i].name}". Please try again later.`, callBack, errorCallBack);
        };

        reader.onabort = () => //console.log('file reading was aborted');

        reader.onerror = () => {
          showMessage('error','File upload failed, please try again later.');
        };

        reader.readAsBinaryString(state.toUploadFiles[i]);
      }
    }
    else{
      setState({errorMessage:errorMessage, uploadDisabled:false});
    }
};

const onDrop = (acceptedFiles, rejectedFiles) => {
  let existingFiles = state.toUploadFiles.slice();
  let bigFiles = state.bigFiles;

  let newState = {};
  for(let i=0;i<acceptedFiles.length;i++){
    let file = acceptedFiles[i];
    file.status = 'Pending';
    file.fileType = '';

    let isBigFile = false;
    if(file.size > 40000000){
      isBigFile = true;
      bigFiles.push(file.name);
    }

    let duplicate = false;
    for(let j=0;j<state.toUploadFiles.length;j++){
      if(state.toUploadFiles[j].name===acceptedFiles[i].name){
        duplicate = true;
        newState = Object.assign({}, newState,{errorMessage:'Duplicate file name "'+acceptedFiles[i].name+'"'});
      }
    }
    if(!duplicate && !isBigFile)
      existingFiles.push(file);
  }
  if(bigFiles.length){
    newState = Object.assign({}, newState,{resizeFilePopUp:true, bigFiles:bigFiles});
  }
  newState = Object.assign({}, newState,{toUploadFiles:existingFiles});
  setState(newState);
};

const getStates = () => {
    const callBack = (response) => {
        const code = response.data.code;
        if (code === '00') {
            const allStates = response.data.data.map(state => ({
                key: state.state,
                value: state.state
            }));
            setState({ states: allStates });
        }
    };

    httpGet('state/get', '', 'Oops, something went wrong and could not load list of available states. Please try again later.', callBack);
};

const removeToUploadFile = (name) => {
  const newFiles = state.toUploadFiles.filter(file => file.name !== name);
  setState({ toUploadFiles: newFiles });
};

const formatFileSize = (size) => {
    const intSize = parseInt(size, 10);
    if (intSize >= 1000000) {
        return formatNumber(Math.round((intSize * 10) / 1000000) / 10) + ' MB';
    } else if (intSize >= 1000) {
        return formatNumber(Math.round((intSize * 10) / 1000) / 10) + ' KB';
    } else {
        return formatNumber(intSize) + ' B';
    }
};

const getAppraiserFiles = () => {
    const callBack = (response) => {
        const code = response.data.code;
        if (code === '00') {
            setState({ appraiserFiles: response.data.data });
        }
    };

    httpGet('appraiser/file/get/' + getSession().userID, '', 'Oops, something went wrong and could not load appraisal files for this appraisal. Please try again later.', callBack);
};

const getFileTypes = () => {
    const callBack = (response) => {
        const code = response.data.code;
        if (code === '00') {
            setState({ fileTypes: response.data.data });
        }
    };

    httpGet('appraiser/file/type/get', '', 'Oops, something went wrong and could not load appraisal file types. Please try again later.', callBack);
};

const removeFileFromList = (ID) => {
    const newAppraiserFiles = state.appraiserFiles.filter(file => file.ID !== ID);
    setState({ appraiserFiles: newAppraiserFiles });
};

const onFileTypeChange = (name, fileType)=>{
  for(let i=0;i<state.toUploadFiles.length;i++){
    if(state.toUploadFiles[i].name===name){
      let newToUploadFiles = [];

      for(let j=0;j<state.toUploadFiles.length;j++){
        let newFile = deepCopyFileObject(state.toUploadFiles[j]);

        if(j===i)
          newFile.fileType = fileType;

        newToUploadFiles.push(newFile);
      }

      setState({toUploadFiles:newToUploadFiles});
    }
  }
}

//constructing a new file object
const deepCopyFileObject = (file)=>{
  let newFile = new File([file],file.name);
  newFile.preview = file.preview;
  newFile.fileType = file.fileType;
  newFile.status = file.status;

  return newFile
}

const generateUpdateFunction = (url, parameters, successMessage, errorMessage, parentCallBack = null) => {
    return (newValue, callBack, errorCallBack) => {
        parameters.push({ field: 'value', value: newValue });
        httpPut(url, parameters, successMessage, errorMessage, callBack, errorCallBack).then(response => {
            if (response.data.code === '00' && parentCallBack) {
                parentCallBack(parameters.find(p => p.field === 'field').value, newValue);
            }
        });
    };
};

  //render
  let bigFileList = state.bigFiles.join(', ');

  const isLowerCaseValid = isPasswordValid(state.newPassword, 'lowercase');
  const isUpperCaseValid = isPasswordValid(state.newPassword, 'uppercase');
  const isSpecialCharacterValid = isPasswordValid(state.newPassword, 'special');
  const isNumberValid = isPasswordValid(state.newPassword, 'number');
  const isLengthValid = isPasswordValid(state.newPassword, 'length');

  let valid = <i className="fa fa-check-circle"></i>;
  let invalid = <i className="fa fa-times-circle"></i>;

  let successMessage = 'Profile updated.';
  let errorMessage = 'Failed to update the value of this field, please try again later.';


  let from, to;
  if(state.appraiser.vacation_start&&state.appraiser.vacation_start!=='0000-00-00')
    from = moment(state.appraiser.vacation_start).toDate();
  else
    from = null;
  if(state.appraiser.vacation_end&&state.appraiser.vacation_end!=='0000-00-00')
    to = moment(state.appraiser.vacation_end).toDate();
  else
    to = null;

  let appraiserFiles;

  if(state.appraiserFiles.length>0){
    appraiserFiles = state.appraiserFiles.map(
      (appraisalFile, outterIndex)=>{

        return(
          <div key={outterIndex}>
            <div className="file-container">
                <div className="font-bold">
                <div className="display-inline cursor-pointer" ><i className="fa fa-trash red-color" onClick={()=>deleteFile(appraisalFile.ID)}></i></div><b>&nbsp;{appraisalFile.file_type}</b>
                <br/><div className="cursor-pointer display-inline link-color" onClick={()=>downloadFile(appraisalFile.name)}><b>{appraisalFile.name}</b></div>
              </div>
              <font size="1"><div className="no-margin no-padding font-bold margin-top-extra"><i className="fa fa-clock-o"></i>&nbsp;{appraisalFile.datetime_created} - {appraisalFile.uploader_name}</div></font>
            </div>
          </div>
        );
      }
    );
  }
  let toUploadFiles;

  if(state.toUploadFiles.length>0){
    toUploadFiles = state.toUploadFiles.map(
      (file,index)=>{
        return(
          <tr key={index}>
            <td style={{borderTop:'none'}}>
              {file.name}
            </td>
            <td style={{borderTop:'none'}}>
              <Input type="select" value={file.fileType} onChange={(e)=>onFileTypeChange(file.name, e.target.value)}>
                {
                  [<option value= ""></option>].concat(state.fileTypes.map(
                    fileType => {
                      return (<option value={fileType.name}>{fileType.name}</option>)
                    }
                  ))
                }
              </Input>
            </td>
            <td style={{borderTop:'none'}}>{formatFileSize(file.size)}</td>
            <td style={{borderTop:'none'}}><center>{file.status}</center></td>
            <td style={{borderTop:'none'}}><center><i className="fa fa-times red-color cursor-pointer" onClick={()=>removeToUploadFile(file.name)}></i></center></td>
          </tr>
        );
      }
    );
  }

  let stateWidget, billingState;

  if(state.states.length>0){
    stateWidget =
      <MyXEditable
      type="select"
      value={state.appraiser.state}
      opt={state.states}
      updateFunc={
        generateUpdateFunction('appraiser/update',[{field:'field',value:'state'},{field:'ID',value:getSession().userID}],successMessage, errorMessage, updateFieldCallBack)
      }
    />;

    billingState =
      <MyXEditable
      type="select"
      value={state.appraiser.billing_state}
      opt={state.states}
      updateFunc={
        generateUpdateFunction('appraiser/update',[{field:'field',value:'billing_state'},{field:'ID',value:getSession().userID}],successMessage, errorMessage, updateFieldCallBack)
      }
    />;
  }

  let templateTags;

  if(state.templateTags.length>0){
    templateTags = state.templateTags.map(
      (tag, index)=>{
        return(
          <div key={index} className="display-inline template-tag" onClick={(e)=>{addTag(e,tag.tag);return false;}}>
            {tag.tag}
          </div>
        );
      }
    );
  }
  let templates;

  if(state.templates.length>0){
    templates = state.templates.map(
      (template, index)=>{
        return(
          <tr key={index}>
            <td width="80%"><i className="fa fa-trash red-color cursor-pointer" onClick={
              ()=>{
                confirmation(
                  ()=>{deleteTemplate(template.ID)},
                  ()=>{},
                  'Delete template?',
                  'Are you sure you want to delete this template?');
              }
            }></i>&nbsp;&nbsp;<NavLink to={"/setting/template/"+template.ID}>{template.name}</NavLink></td><td><div className="align-right">{formatDate(template.datetime_created)}</div></td>
          </tr>
        )
      }
    );
  }

  let smsSubscribed = false;

  if(state.appraiser.sms_subscription&&state.appraiser.sms_subscription==='yes')
    smsSubscribed = true;

  let appraisalTypes;
  let missingTypes = [];
  if(state.appraisalTypes.length>0){
    for(let i=0;i<state.appraisalTypes.length;i++){
      let found = false;
      for(let j=0;j<state.appraisalTypeFees.length;j++){
        if(state.appraisalTypes[i].value===state.appraisalTypeFees[j].appraisal_type)
          found = true;
      }

      if(!found)
        missingTypes.push(state.appraisalTypes[i]);
    }


    appraisalTypes = missingTypes.map(
      (appraisalType,index)=>{

        return(
          <option key={index} value={appraisalType.key}>{appraisalType.value}</option>
        );
      }
    );
  }

  let profileContent;

  if(state.showUpload){
    profileContent = <div>
      <Avatar
        width={300}
        height={250}
        onCrop={onCrop}
        onClose={onClose}
        onBeforeFileLoad={onBeforeFileLoad}
        src={state.photoSrc}
        label="Click to upload photo"
      />
      <br/>
      <Button color="info" onClick={(e)=>setState({showUpload:false})}><i className="fa fa-times"/> Cancel</Button>&nbsp;&nbsp;<Button color="warning" onClick={uploadProfilePhoto}><i className="fa fa-upload"/> Upload</Button>
    </div>
  }
  else{
    if(state.profileUrl && state.profileUrl!==''){
      profileContent = <div>
        <div className="align-left">
          <NavLink to="#" onClick={(e)=>setState({showUpload:true})}><i className="green-color fa fa-plus"/> Upload Profile Photo</NavLink>
          <br/><br/>
        </div>
        <img src={state.profileUrl} width="200" style={{marginTop:'13px'}}/>
        <br/><br/><br/>
      </div>
    }
  }
  
  return <div className="my-well">
  <Row>
    <Col sm="6">
      <div className="page-title">
        <i className="fa fa-reorder"></i>&nbsp;Settings
      </div>
    </Col>
    <Col sm="6">

    </Col>
  </Row>
  <div className="my-divider"></div>
  <Row>
    <Col sm="8">
      <Card>
        <CardHeader className="header-color">
          <i className="fa fa-user"></i> My profile
        </CardHeader>
        <CardBody>
          <Table className="table table-striped">
            <tbody>
              <tr>
                <td>
                  <NavLink to="#" onClick={documentToggle}>My document</NavLink>
                  <br/>
                  Upload & download your personal documents like W9, resume & license etc.
                </td>
              </tr>
              <tr>
                <td>
                  <NavLink to="#" onClick={responseTimeAndpreferredToggle}>My response time & preferred communication method.</NavLink>
                  <br/>
                  Set a preferrence of your preferred communication method & average response time to new assignments.
                </td>
              </tr>
              <tr>
                <td>
                  <b>SMS subscription</b>
                  <br/>
                  <Row>
                    <Col sm="8">
                      Subscribe to our sms notification for new order assignments.
                    </Col>
                    <Col sm="4" className="align-right">
                      <Toggle
                        checked={smsSubscribed}
                        icons={false}
                        onChange={smsSubscriptionChange}
                      />
                    </Col>
                  </Row>
                </td>
              </tr>
              <tr>
                <td>
                  <NavLink to="#" onClick={vacationToggle}>Vacation schedule</NavLink>
                  <br/>
                  Set your vacation schedule so we won't be bothering you for new assignments.
                </td>
              </tr>
              <tr>
                <td>
                  <NavLink to={"/setting/profile"}>About me</NavLink>
                  <br/>
                  Edit your personal information like address, billing address, phone, email to notify etc.
                </td>
              </tr>
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </Col>
    <Col sm="4">
      <Card>
        <CardHeader className="header-color">
          <i className="fa fa-image"/> Profile Photo
        </CardHeader>
        <CardBody>
          <center>
            {profileContent}
          </center>
        </CardBody>
      </Card>
    </Col>
  </Row>
  
  <br/>
  <div className="card">
    <div className="card-header header-color">
      <Row>
        <Col sm="8">
          <i className="fa fa-edit"></i>&nbsp;Templates
        </Col>
        <Col sm="4">
          <div className="align-right">
            <div className="display-inline cursor-pointer" onClick={toggleAddNewTemplateDropDown}>
              <i className="fa fa-plus green-color"></i> Add new template
            </div>
          </div>
          <Modal className="my-modal" isOpen={state.addNewTemplateDropDownOpen} toggle={toggleAddNewTemplateDropDown} >
            <ModalHeader hidden={true} toggle={toggleAddNewTemplateDropDown}></ModalHeader>
            <ModalBody>
              <center>
                <h5><i className="fa fa-plus"></i> Add new template</h5>
              </center>
              <br/>
              <form onSubmit={addNewTemplate}>
                <label><font color="red">*</font>Name</label>
                <Input required={true} type="text" value={state.newTemplateName} onChange={(e)=>setState({newTemplateName:e.target.value})}/>

                <label><font color="red">*</font>Template</label>
                <Input required={true} type="textarea" rows="10" style={{resize:'none'}} value={state.newTemplateText} onChange={(e)=>setState({newTemplateText:e.target.value})}/>
                <br/>
                <b>Tags:</b> {templateTags}
                <br/>
                <center>
                  <Button color="warning"><i className="green-color fa fa-plus"></i>&nbsp;Add</Button>&nbsp;
                  <Button color="info" onClick={toggleAddNewTemplateDropDown}>Close</Button>
                </center>
              </form>
            </ModalBody>
          </Modal>
        </Col>
      </Row>
    </div>
    <div className="card-body">
      <div className="medium-scroll-container">
        <Table className="table table-striped">
          <tbody>
            {templates}
          </tbody>
        </Table>
      </div>
    </div>
  </div>

  <br/>

  <Card>
    <CardHeader className="header-color">
      <i className="fa fa-tasks"></i>&nbsp;Email notification
    </CardHeader>
    <CardBody>
      <div className="large-scroll-container">
        <table className="table table-striped">
          <tbody>
          {
            state.emailSettings.map(
              (emailSetting,index)=>{
                return(
                  <tr key={index}>
                    <td>
                        <Row>
                          <Col sm="6">
                            {emailSetting.subject}
                          </Col>
                          <Col sm="6" className="align-right">
                            <Toggle
                              checked={emailSetting.blocked==='no'}
                              icons={false}
                              onChange={()=>emailNotificationToggle(emailSetting.subject)} />
                          </Col>
                        </Row>
                    </td>
                  </tr>
                )
              }
            )
          }
          </tbody>
        </table>
      </div>
    </CardBody>
  </Card>

  <br/>

  <br/>

  <Card>
    <CardHeader className="header-color">
      <i className="fa fa-tasks"></i>&nbsp;Update password
    </CardHeader>
    <CardBody>
      <div style={{height:'30px'}}>
        <label><font color="red">{state.changePasswordMessage}</font></label>
      </div>
      <label>Your email</label><br/>
      {getSession().email}
      <br/><br/>
      <label>Your current password</label>
      <input className="form-control" type="password" value={state.oldPassword} onChange={(e)=>setState({oldPassword:e.target.value})}/>

      <label>New password</label>
      <div className="input-container">
        <input className="form-control" type={state.showPassword ? 'text' : 'password'} value={state.newPassword} onChange={handlePasswordChange}
          onFocus={handlePasswordFocus}
          onBlur={handlePasswordBlur}
          pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
          title="Must contain at least one number, one special character, one uppercase and lowercase letter, and at least 12 or more characters"
          required
        />
        <span className="toggle-button" onClick={handleToggle}>
          {state.showPassword ? <i className="fa fa-eye"></i> : <i className="fa fa-eye-slash"></i>}
        </span>
      </div>

      <label>Confirm password</label>
      <input className="form-control" type="password" value={state.confirmNewPassword} onChange={(e)=>setState({confirmNewPassword:e.target.value})}/>
      <br/>
      {state.isFocused && (
        <div id="message">
          <label>Password must contain the following:</label>
          <p id="letter" style={{lineHeight:'3px'}} className={(isLowerCaseValid&&isUpperCaseValid)? 'green-color' : 'red-color'}>
            {(isLowerCaseValid&&isUpperCaseValid)? valid:invalid} Combination of uppercase letters & lowercase letters
          </p>
          <p id="number" style={{lineHeight:'3px'}} className={isNumberValid? 'green-color' : 'red-color'}>
            {isNumberValid? valid:invalid} At least 1 number (0-9)
          </p>
          <p id="special-char" style={{lineHeight:'3px'}} className={isSpecialCharacterValid? 'green-color' : 'red-color'}>
            {isSpecialCharacterValid? valid:invalid} At least 1 special Chracter (!@#$%^&*)
          </p>
          <p id="length" style={{lineHeight:'3px'}} className={isLengthValid? 'green-color' : 'red-color'}>
            {isLengthValid? valid:invalid} Minimum <b>12 characters</b>
          </p>
        </div>
      )}   
      <br/>

      <div className="align-right">
        <Button color="warning" onClick={updatePassword}>Update password</Button>
      </div>
    </CardBody>
  </Card>
  <Modal className="my-modal" isOpen={state.appraiserFeePopUp} toggle={feeToggle} >
    <ModalHeader hidden={true} toggle={feeToggle}></ModalHeader>
    <ModalBody>
      <div className="large-scroll-container">
        <Table className="table table-striped">
          <thead>
            <tr>
              <th width="15%">Action</th>
              <th width="60%">Report Type</th>
              <th width="25%">Fee</th>
            </tr>
          </thead>
          <tbody>
          {
            state.appraisalTypeFees.map(
              (appraisalTypeFee,index)=>{
                return(
                  <tr key={index}>
                    <td><i className="fa fa-times cursor-pointer" onClick={()=>removeAppraisalTypeFee(appraisalTypeFee.ID)}></i></td>
                    <td>{appraisalTypeFee.label}</td>
                    <td>
                      <MyXEditable
                      type="text"
                      prefix="$"
                      value={appraisalTypeFee.fee}
                      updateFunc={
                        generateUpdateFunction('appraiser/appraisalTypeFees/update',[{field:'field',value:'fee'},{field:'ID',value:appraisalTypeFee.ID}],successMessage, errorMessage)
                      }
                    /></td>
                  </tr>
                );
              }
            )
          }
          </tbody>
        </Table>
      </div>
      <div className="my-divider">&nbsp;</div>
      <form onSubmit={submitNewAppraisalTypeFee}>
        <label>Report Type:</label>
        <Input required="true" type="select" value={state.newAppraisalTypeFeeSelection} onChange={(e)=>setState({newAppraisalTypeFeeSelection:e.target.value})}>
          <option value=""></option>
          {appraisalTypes}
        </Input>
        <br/>
        <label>Fee:</label>
        <Input required="true" type="text" value={state.newAppraisalTypeFeeAmount} onChange={(e)=>setState({newAppraisalTypeFeeAmount:e.target.value})}/>

        <br/>
        <center>
          <Button color="warning"><i className="green-color fa fa-plus"></i>&nbsp;Add</Button>&nbsp;
          <Button color="info" onClick={feeToggle}>Close</Button>
        </center>
      </form>
    </ModalBody>
  </Modal>
  <Modal className="my-modal" isOpen={state.resizeFilePopUp} toggle={toggleResizeFile} >
    <ModalHeader hidden={true} toggle={toggleResizeFile}></ModalHeader>
    <ModalBody>
      <center>
        <h5><i className="fa fa-exclamation-triangle"></i> File Too Large</h5>
      </center>

      <b>Your file is larger than <font color="red">40MB</font>. Please resize your following file(s):</b>
      <div>{bigFileList}</div>

      <br/><br/>
      <center>
        <Button color="warning" onClick={toggleResizeFile}>Ok</Button>
      </center>
    </ModalBody>
  </Modal>
  <Modal className="my-modal" isOpen={state.appraiserDocumentPopUp} toggle={documentToggle} >
    <ModalHeader hidden={true} toggle={documentToggle}></ModalHeader>
    <ModalBody>
      <b>My doucuments</b>
      <div className="appraiser-file-panel">
        {appraiserFiles}
      </div>
      <div className="my-diviver"></div>
      <div className="align-right">
        <div className="my-divider">&nbsp;</div>
        <div>
          <MyDropzone onDrop={onDrop}/>
          <br/>
          <div className="my-divider"></div>
          <div className="small-scroll-container red-color flashit" style={{minHeight:'30px',height:'30px ',maxHeight:'30px'}}>
            <b>{state.errorMessage}</b>
          </div>
          <div className="medium-scroll-container">
            <table className="table file-list-table" cellSpacing="0" cellPadding="0">
              <thead>
                <tr>
                  <th width="30%">Name</th>
                  <th width="35%">File Type</th>
                  <th width="15%">Size</th>
                  <th width="10%"><center>Status</center></th>
                  <th width="10%">Control</th>
                </tr>
              </thead>
              <tbody>
                {toUploadFiles}
              </tbody>
            </table>
          </div>
          <br/>

          <center>
            <Button color="warning" disabled={state.uploadDisabled} onClick={buttonHandler}><i className="fa fa-upload"></i> Upload</Button>&nbsp;
            <Button color="info" onClick={documentToggle}>Close</Button>
          </center>
        </div>
      </div>
    </ModalBody>
  </Modal>

  <Modal className="my-modal" isOpen={state.appraiserVacationSchedulePopUp} toggle={vacationToggle} >
    <ModalHeader hidden={true} toggle={vacationToggle}></ModalHeader>
    <ModalBody>
      <br/>
      <i><b><font color="red">**</font>Set your vacation so we won't send bid/assignment your way.</b></i>
      <br/><br/>
      <Row>
        <Col sm="6">
          <label>From</label>&nbsp;
          <DatePicker
            className="form-control"
            selected={from}
            onChange={(text)=>{(text)&&setState({appraiser:Object.assign({},state.appraiser,{vacation_start:text.toLocaleDateString('en-CA')})})}}
          />
        </Col>
        <Col sm="6">
          <label>To</label>&nbsp;
          <DatePicker
            className="form-control"
            selected={to}
            onChange={(text)=>{(text)&&setState({appraiser:Object.assign({},state.appraiser,{vacation_end:text.toLocaleDateString('en-CA')})})}}
          />
        </Col>
      </Row>
      <br/><br/><br/><br/><br/><br/>
      <br/><br/>
      <div className="my-divider">&nbsp;</div>
      <center>
        <Button color="warning" onClick={()=>{updateField('vacation_start',state.appraiser.vacation_start);updateField('vacation_end',state.appraiser.vacation_end)}}><i className="green-color fa fa-plus"></i>&nbsp;Update</Button>&nbsp;
        <Button color="info" onClick={vacationToggle}>Close</Button>
      </center>
    </ModalBody>
  </Modal>
  <Modal className="my-modal" isOpen={state.appraiserResponseTimeAndpreferredPopUp} toggle={responseTimeAndpreferredToggle} >
    <ModalHeader hidden={true} toggle={responseTimeAndpreferredToggle}></ModalHeader>
    <ModalBody>
      <br/>
      <Row>
        <Col sm="6">
          <label>Response time</label>
          <Input type="text" value={state.appraiser.response_time} onChange={(e)=>{setState({appraiser:Object.assign({},state.appraiser,{response_time:e.target.value})})}}/>

          <br/>
          <Button className="form-control" color="warning" onClick={()=>updateField('response_time',state.appraiser.response_time)}>Update response time</Button>
        </Col>
        <Col sm="6">
          <label>Preferred communication method</label>
          <Input type="select" value={state.appraiser.preferred_communication} onChange={(e)=>{setState({appraiser:Object.assign({},state.appraiser,{preferred_communication:e.target.value})})}}>
            <option value=""></option>
            {
              state.communicationMethods.map(
                (method,index)=>{
                  return <option key={index} value={method.method}>{method.method}</option>
                }
              )
            }
          </Input>
          <br/>
          <Button className="form-control" color="warning" onClick={()=>updateField('preferred_communication',state.appraiser.preferred_communication)}>Update preference</Button>
        </Col>
      </Row>

      <div className="my-divider">&nbsp;</div>
      <center>
        <Button color="info" onClick={responseTimeAndpreferredToggle}>Close</Button>
      </center>
    </ModalBody>
  </Modal>
  <Modal className="my-modal" isOpen={state.appraiserAboutMePopUp} toggle={aboutMeToggle} >
    <ModalHeader hidden={true} toggle={aboutMeToggle}></ModalHeader>
    <ModalBody>
      <Row>
        <Col sm="6">
          <Row>
            <Col sm="4">
              Phone
            </Col>
            <Col sm="8">
              <MyXEditable
                type="text"
                value={state.appraiser.phone}
                updateFunc={
                  generateUpdateFunction('appraiser/update',[{field:'field',value:'phone'},{field:'ID',value:getSession().userID}],successMessage, errorMessage, updateFieldCallBack)
                }
              />
            </Col>
          </Row>
          <Row>
            <Col sm="4">
              Notify email
            </Col>
            <Col sm="8">
              <MyXEditable
                type="text"
                value={state.appraiser.notify_emails}
                updateFunc={
                  generateUpdateFunction('appraiser/update',[{field:'field',value:'notify_emails'},{field:'ID',value:getSession().userID}],successMessage, errorMessage, updateFieldCallBack)
                }
              />
            </Col>
          </Row>
          <br/>
          <Row>
            <Col sm="4">
              Street
            </Col>
            <Col sm="8">
              <MyXEditable
                type="text"
                value={state.appraiser.street}
                updateFunc={
                  generateUpdateFunction('appraiser/update',[{field:'field',value:'street'},{field:'ID',value:getSession().userID}],successMessage, errorMessage, updateFieldCallBack)
                }
              />
            </Col>
          </Row>
          <Row>
            <Col sm="4">
              City
            </Col>
            <Col sm="8">
              <MyXEditable
                type="text"
                value={state.appraiser.city}
                updateFunc={
                  generateUpdateFunction('appraiser/update',[{field:'field',value:'city'},{field:'ID',value:getSession().userID}],successMessage, errorMessage, updateFieldCallBack)
                }
              />
            </Col>
          </Row>
          <Row>
            <Col sm="4">
              State
            </Col>
            <Col sm="8">
              {stateWidget}
            </Col>
          </Row>
          <Row>
            <Col sm="4">
              Zip
            </Col>
            <Col sm="8">
              <MyXEditable
                type="text"
                value={state.appraiser.zip}
                updateFunc={
                  generateUpdateFunction('appraiser/update',[{field:'field',value:'zip'},{field:'ID',value:getSession().userID}],successMessage, errorMessage, updateFieldCallBack)
                }
              />
            </Col>
          </Row>
        </Col>
        <Col sm="6">
          <Row>
            <Col sm="4">
              Billing street
            </Col>
            <Col sm="8">
              <MyXEditable
                type="text"
                value={state.appraiser.billing_street}
                updateFunc={
                  generateUpdateFunction('appraiser/update',[{field:'field',value:'billing_street'},{field:'ID',value:getSession().userID}],successMessage, errorMessage, updateFieldCallBack)
                }
              />
            </Col>
          </Row>
          <Row>
            <Col sm="4">
              Billing city
            </Col>
            <Col sm="8">
              <MyXEditable
                type="text"
                value={state.appraiser.billing_city}
                updateFunc={
                  generateUpdateFunction('appraiser/update',[{field:'field',value:'billing_city'},{field:'ID',value:getSession().userID}],successMessage, errorMessage, updateFieldCallBack)
                }
              />
            </Col>
          </Row>
          <Row>
            <Col sm="4">
              Billing state
            </Col>
            <Col sm="8">
              {billingState}
            </Col>
          </Row>
          <Row>
            <Col sm="4">
              Billing zip
            </Col>
            <Col sm="8">
              <MyXEditable
                type="text"
                value={state.appraiser.billing_zip}
                updateFunc={
                  generateUpdateFunction('appraiser/update',[{field:'field',value:'billing_zip'},{field:'ID',value:getSession().userID}],successMessage, errorMessage, updateFieldCallBack)
                }
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <br/>

      <Row>
        <Col sm="4">
          E&O Expiration Date
        </Col>
        <Col sm="8">
          <MyXEditable
            type="date"
            value={state.appraiser.eo_expiration_date}
            updateFunc={
              generateUpdateFunction('appraiser/update',[{field:'field',value:'eo_expiration_date'},{field:'ID',value:getSession().userID}],successMessage, errorMessage, updateFieldCallBack)
            }
          />
        </Col>
      </Row>
      <div className="my-divider">&nbsp;</div>
      <center>
        <Button color="info" onClick={aboutMeToggle}>Close</Button>
      </center>
    </ModalBody>
  </Modal>

  <br/>
</div>;
}

export default PersonalSetting;